import GableMark from './GableMark';
import './leadership-portrait.css';

/**
 * Renders a leadership photograph when one exists, and a designed monogram
 * when one does not.
 *
 * The fallback is intentional, not a broken-image placeholder: it looks like
 * a considered brand element rather than a gap, so the page holds together
 * until the client supplies a real headshot.
 */
const LeadershipPortrait = ({ person, className = '' }) => {
  if (person.photo) {
    return (
      <img
        src={person.photo}
        alt={person.photoAlt}
        className={`leader-portrait__photo ${className}`.trim()}
        loading="lazy"
      />
    );
  }

  return (
    <div className={`leader-portrait ${className}`.trim()} role="img" aria-label={`${person.name}, ${person.role}`}>
      <GableMark className="leader-portrait__motif" />
      <span className="leader-portrait__initials" aria-hidden="true">
        {person.initials}
      </span>
      <span className="leader-portrait__rule" aria-hidden="true" />
      <span className="leader-portrait__name" aria-hidden="true">
        {person.name}
      </span>
      <span className="leader-portrait__role" aria-hidden="true">
        {person.role}
      </span>
    </div>
  );
};

export default LeadershipPortrait;
